// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mvxt","left":"styles_left__2gtsO"};